import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { useAuth } from '../../AuthContext';

/**
 * Sends signed-out visitors to /login and back again afterwards.
 *
 * Two details matter for links that carry a query string, such as Strava returning with
 * ?code=…&state=…:
 * - msal-react reports no accounts until it has finished starting up, so deciding during
 *   startup would bounce a signed-in user through /login on every full page load.
 * - The return address keeps the query and hash, not just the path, or the code is lost.
 */
function RequireAuth({ children }) {
  const { isAuthenticated } = useAuth();
  const { inProgress } = useMsal();
  const location = useLocation();

  if (isAuthenticated) return children;
  if (inProgress !== InteractionStatus.None) return null;

  const from = `${location.pathname}${location.search}${location.hash}`;
  return <Navigate to="/login" state={{ from }} replace />;
}

export default RequireAuth;
